/* eslint-disable */
// ** I18n Imports
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import translationSP from '../../locales/sp/translation.json'
import translationENG from '../../locales/eng/translation.json'
// the translations
const resources = {
  es: {
    translation: translationSP,
  },
  en: {
    translation: translationENG,
  },
}


i18n

  // Enable automatic language detection
  .use(LanguageDetector)

  // Enables the hook initialization module
  .use(initReactI18next)
  .init({
    lng: 'es',
    // Las dos traducciones van empaquetadas arriba, en `resources`. Antes había además
    // un backend XHR que las buscaba en /assets/data/locales/{{lng}}.json, pero allí solo
    // vivían los ficheros de ejemplo de Vuexy (de, en, fr, pt): nunca hubo un es.json, así
    // que el backend jamás sirvió nada. Se retira junto con esos ficheros.
    resources,
    fallbackLng: 'en',
    debug: false,
    keySeparator: false,
    react: {
      useSuspense: false
    },
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    }
  })

export default i18n
